export class Utils {
  
    static hasValue(param: any): boolean {
      return !this.isNullOrUndefined(param) && param !== "";
    }

    static isNullOrUndefined(param: any): boolean {
        return param === undefined || param === null;
    }
  }